import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Typography from '@material-ui/core/Typography';

const styles = theme => ({
  root: {
    color: theme.palette.primary.main,
    paddingBottom: theme.spacing(1),
    marginBottom: theme.spacing(3),
    borderBottom: '1px solid',
    borderBottomColor: theme.palette.grey[300],
  },
});

const categoryToTitleMap = {
  onboarding: 'Onboarding',
  insurance: 'Insurance',
  debt: 'Debt',
  investments: 'Investments',
  education: 'Education',
  'employee-benefits': 'Employee Benefits',
  'cashflow-budget': 'Budget',
};

const getTitleFromCategory = (category) => {
  return categoryToTitleMap[category] || '';
};

const PlaybookPredefinedTaskTitle = ({
  className,
  classes,
  value,
}) => {
  return (
    <Typography
      variant="h2"
      className={classNames(classes.root, className)}
    >
      {getTitleFromCategory(value)}
    </Typography>
  );
};

PlaybookPredefinedTaskTitle.defaultProps = {
  className: '',
};

PlaybookPredefinedTaskTitle.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  value: PropTypes.string.isRequired,
};

export default withStyles(styles)(PlaybookPredefinedTaskTitle);
